import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Grid,
  TextField,
  Typography,
  useTheme,
  Avatar,
  Divider,
  InputAdornment,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import Header from "components/Header";
import {
  WorkHistory,
  CalculateOutlined,
  MoneyOutlined,
  Savings,
  AddCircleOutline,
  CancelOutlined,
} from "@mui/icons-material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getNamaBulan } from "utils/namaBulan";
import FlexStart from "components/FlexStart";
import { fetchEditListGaji } from "state/gajiAction";
import { setMessage, setStatus } from "state";
import FloatingAlert from "components/FloatingAlert";
import moment from "moment";
import "moment/locale/id";
import { fetchSummaryAbsensi } from "state/karyawanActions";
moment.locale("id");
// Schema validasi pakai Yup
const validationSchema = Yup.object({
  id_karyawan: Yup.mixed().required("ID Karyawan wajib diisi"),
  gaji_pokok: Yup.number().required("Gaji Pokok wajib diisi"),
  lembur: Yup.number(),
  rajin: Yup.number(),
  transportasi: Yup.number(),
  pulsa: Yup.number(),
  tunjangan_jabatan: Yup.number(),
  uang_makan: Yup.number(),
  potongan_tabungan: Yup.number(),
  potongan_pinjaman: Yup.number(),
});

const EditPenggajian = () => {
  const theme = useTheme();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const location = useLocation();
  const { dataEdit } = location.state || {};

  const { status, message } = useSelector((state) => state.global);
  const { summary_absensi } = useSelector((state) => state.karyawan);
  const [baseGajiPokok, setBaseGajiPokok] = useState(0);
  const [baseTotalHadir, setBaseTotalHadir] = useState(0);
  useEffect(() => {
    if (dataEdit.id_karyawan !== null) {
      dispatch(
        fetchSummaryAbsensi(
          dataEdit.id_karyawan,
          dataEdit.bulan,
          dataEdit.tahun
        )
      );
    }
  }, [dataEdit]);
  const handleCloseSnackbar = () => {
    navigate(-1);
    formik.resetForm();
    dispatch(setStatus("default"));
    dispatch(setMessage(""));
  };

  const formik = useFormik({
    initialValues: {
      id_karyawan: null,
      gaji_pokok: 0,
      lembur: 0,
      rajin: 0,
      transportasi: 0,
      pulsa: 0,
      tunjangan_jabatan: 0,
      uang_makan: 0,
      potongan_nbh: 0,
      sisa_nbh_bln_ini: 0,
      nbh_bln_ini: 0,
      potongan_tabungan: 0,
      potongan_pinjaman: 0,
    },
    validationSchema,
    onSubmit: (values) => {
      const reqData = {
        rajin: values.rajin,
        tunjangan_jabatan: values.tunjangan_jabatan,
        gaji_pokok: values.gaji_pokok,
        lembur: values.lembur,
        uang_makan: values.uang_makan,
        potongan_nbh: values.potongan_nbh,
        sisa_nbh_bln_ini: values.sisa_nbh_bln_ini,
        nbh_bln_ini: values.nbh_bln_ini,
        sisa_nbh: hitungSisaNBH(),
        potongan_tabungan: values.potongan_tabungan,
        potongan_pinjaman: values.potongan_pinjaman,
        total_gaji: hitungTotalGaji(),
      };
      dispatch(fetchEditListGaji(dataEdit.id, reqData));
    },
  });

  useEffect(() => {
    if (dataEdit) {
      kalkulasiGajiKaryawan();
      formik.setFieldValue("id_karyawan", parseFloat(dataEdit?.id_karyawan));
      formik.setFieldValue("gaji_pokok", parseFloat(dataEdit?.gaji_pokok));
      formik.setFieldValue("lembur", parseFloat(dataEdit?.lembur));
      formik.setFieldValue("nbh_bln_ini", parseFloat(dataEdit?.nbh_bln_ini));
      formik.setFieldValue("potongan_nbh", parseFloat(dataEdit?.potongan_nbh));
      formik.setFieldValue("rajin", parseFloat(dataEdit?.rajin));
      formik.setFieldValue(
        "potongan_pinjaman",
        parseFloat(dataEdit?.potongan_pinjaman)
      );
      formik.setFieldValue(
        "potongan_tabungan",
        parseFloat(dataEdit?.potongan_tabungan)
      );
    }
  }, [dataEdit]);
  useEffect(() => {
    if (baseGajiPokok > 0) {
      kalkulasiGajiKaryawan();
      setBaseTotalHadir(dataEdit?.jumlah_hadir);
      const calculateGaji = Math.round(
        (baseGajiPokok / 26) * dataEdit?.jumlah_hadir
      );
      kalkulasiUangMakan(dataEdit?.jumlah_hadir);
      formik.setFieldValue("gaji_pokok", calculateGaji);
    }
  }, [baseGajiPokok]);

  const hitungIncome = () => {
    const {
      gaji_pokok = 0,
      lembur = 0,
      rajin = 0,
      transportasi = 0,
      pulsa = 0,
      tunjangan_jabatan = 0,
      uang_makan = 0,
    } = formik.values;

    const totalPendapatan =
      Number(gaji_pokok) +
      Number(lembur) +
      Number(rajin) +
      Number(transportasi) +
      Number(pulsa) +
      Number(tunjangan_jabatan) +
      Number(uang_makan);
    return totalPendapatan;
  };

  const hitungOutcome = () => {
    const {
      potongan_nbh = 0,
      potongan_tabungan = 0,
      potongan_pinjaman = 0,
    } = formik.values;

    const totalPotongan =
      Number(potongan_nbh) +
      Number(potongan_tabungan) +
      Number(potongan_pinjaman);

    return totalPotongan;
  };
  const hitungTotalGaji = () => {
    const {
      gaji_pokok = 0,
      lembur = 0,
      rajin = 0,
      transportasi = 0,
      pulsa = 0,
      tunjangan_jabatan = 0,
      uang_makan = 0,
      potongan_nbh = 0,
      potongan_tabungan = 0,
      potongan_pinjaman = 0,
    } = formik.values;

    const totalPendapatan =
      Number(gaji_pokok) +
      Number(lembur) +
      Number(rajin) +
      Number(transportasi) +
      Number(pulsa) +
      Number(tunjangan_jabatan) +
      Number(uang_makan);

    const totalPotongan =
      Number(potongan_nbh) +
      Number(potongan_tabungan) +
      Number(potongan_pinjaman);

    return totalPendapatan - totalPotongan;
  };

  const formatRupiah = (amount) => {
    if (amount === null || amount === undefined) return "Rp 0";

    const absoluteAmount = Math.abs(amount);

    const formatted = absoluteAmount.toLocaleString("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });

    return `Rp ${formatted}`;
  };

  const hitungSisaNBH = () => {
    const {
      potongan_nbh = 0,
      sisa_nbh_bln_ini = 0,
      nbh_bln_ini = 0,
    } = formik.values;

    const sisa_nbh_skrg =
      Number(sisa_nbh_bln_ini) + Number(nbh_bln_ini) - Number(potongan_nbh);

    return sisa_nbh_skrg;
  };

  const hitungEstimasiTabungan = () => {
    const { potongan_tabungan = 0 } = formik.values;

    const est_tabungan =
      Number(dataEdit?.total_tabungan) -
      Number(dataEdit?.potongan_tabungan) +
      Number(potongan_tabungan);

    return est_tabungan;
  };

  const kalkulasiGajiKaryawan = () => {
    const listRetail = ["PC 02", "PC 03", "PC 04", "PC 05", "PC 07", "PC 11"];
    const listSemiGrosir = ["PC 08", "PC 09", "PC 10", "PC 12"];
    const listGrosir = ["PC 01", "PC 06"];

    const GAJI_DATA = {
      Retail: {
        SMA: {
          "Kepala Toko(KT)": {
            gaji_pokok: 2150000,
            transportasi: 100000,
            pulsa: 50000,
            tunjangan_jabatan: 500000,
            potongan_tabungan: 100000,
          },
          "Asisten Kepala Toko(AKT)": {
            gaji_pokok: 1869900,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 300000,
            potongan_tabungan: 75000,
          },
          "Merchandiser (MD)": {
            gaji_pokok: 1585000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 200000,
            potongan_tabungan: 50000,
          },
          "Kasir": {
            gaji_pokok: 1485000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 150000,
            potongan_tabungan: 30000,
          },
          "Pramuniaga (Pramu)": {
            gaji_pokok: 1485000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 0,
            potongan_tabungan: 30000,
          },
          "Trainee": {
            gaji_pokok: 1477890,
            transportasi: 0,
            pulsa: 0,
            tunjangan_jabatan: 0,
            potongan_tabungan: 0,
          },
        },
        SMP: {
          "Kepala Toko(KT)": {
            gaji_pokok: 1600000,
            transportasi: 100000,
            pulsa: 50000,
            tunjangan_jabatan: 500000,
            potongan_tabungan: 100000,
          }, // Perhatikan: gaji pokok KT SMP sama dengan KT SMA di Retail
          "Asisten Kepala Toko(AKT)": {
            gaji_pokok: 1429900,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 300000,
            potongan_tabungan: 75000,
          }, // Perhatikan: gaji pokok AKT SMP sama dengan AKT SMA di Retail
          "Merchandiser (MD)": {
            gaji_pokok: 1314900,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 200000,
            potongan_tabungan: 50000,
          },
          "Kasir": {
            gaji_pokok: 935000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 150000,
            potongan_tabungan: 30000,
          }, // Perhatikan: gaji pokok Merchandiser SMP sama dengan Merchandiser SMA di Retail
          "Pramuniaga (Pramu)": {
            gaji_pokok: 935000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 0,
            potongan_tabungan: 30000,
          },
          "Trainee": {
            gaji_pokok: 927890,
            transportasi: 0,
            pulsa: 0,
            tunjangan_jabatan: 0,
            potongan_tabungan: 0,
          },
        },
      },
      "Semi Grosir": {
        SMA: {
          "Kepala Toko(KT)": {
            gaji_pokok: 2150000,
            transportasi: 100000,
            pulsa: 50000,
            tunjangan_jabatan: 600000,
            potongan_tabungan: 100000,
          },
          "Asisten Kepala Toko(AKT)": {
            gaji_pokok: 1869900,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 300000,
            potongan_tabungan: 75000,
          },
          "Merchandiser (MD)": {
            gaji_pokok: 1585000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 200000,
            potongan_tabungan: 50000,
          },
          "Kasir": {
            gaji_pokok: 1485000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 150000,
            potongan_tabungan: 30000,
          },
          "Pramuniaga (Pramu)": {
            gaji_pokok: 1485000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 0,
            potongan_tabungan: 30000,
          },
          "Trainee": {
            gaji_pokok: 1477890,
            transportasi: 0,
            pulsa: 0,
            tunjangan_jabatan: 0,
            potongan_tabungan: 0,
          },
        },
        SMP: {
          "Kepala Toko(KT)": {
            gaji_pokok: 1600000,
            transportasi: 100000,
            pulsa: 50000,
            tunjangan_jabatan: 500000,
            potongan_tabungan: 100000,
          }, // Perhatikan: gaji pokok KT SMP sama dengan KT SMA di Retail
          "Asisten Kepala Toko(AKT)": {
            gaji_pokok: 1429900,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 300000,
            potongan_tabungan: 75000,
          }, // Perhatikan: gaji pokok AKT SMP sama dengan AKT SMA di Retail
          "Merchandiser (MD)": {
            gaji_pokok: 1314900,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 200000,
            potongan_tabungan: 50000,
          },
          "Kasir": {
            gaji_pokok: 935000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 150000,
            potongan_tabungan: 30000,
          }, // Perhatikan: gaji pokok Merchandiser SMP sama dengan Merchandiser SMA di Retail
          "Pramuniaga (Pramu)": {
            gaji_pokok: 935000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 0,
            potongan_tabungan: 30000,
          },
          "Trainee": {
            gaji_pokok: 927890,
            transportasi: 0,
            pulsa: 0,
            tunjangan_jabatan: 0,
            potongan_tabungan: 0,
          },
        },
      },
      Grosir: {
        SMA: {
          "Kepala Toko(KT)": {
            gaji_pokok: 2150000,
            transportasi: 100000,
            pulsa: 50000,
            tunjangan_jabatan: 750000,
            potongan_tabungan: 100000,
          },
          "Asisten Kepala Toko(AKT)": {
            gaji_pokok: 1869900,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 400000,
            potongan_tabungan: 75000,
          },
          "Merchandiser (MD)": {
            gaji_pokok: 1585000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 240000,
            potongan_tabungan: 50000,
          },
          "Kasir": {
            gaji_pokok: 1485000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 150000,
            potongan_tabungan: 30000,
          },
          "Pramuniaga (Pramu)": {
            gaji_pokok: 1485000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 0,
            potongan_tabungan: 30000,
          },
          "Trainee": {
            gaji_pokok: 1477890,
            transportasi: 0,
            pulsa: 0,
            tunjangan_jabatan: 0,
            potongan_tabungan: 0,
          },
        },
        SMP: {
          "Kepala Toko(KT)": {
            gaji_pokok: 1600000,
            transportasi: 100000,
            pulsa: 50000,
            tunjangan_jabatan: 500000,
            potongan_tabungan: 100000,
          },
          "Asisten Kepala Toko(AKT)": {
            gaji_pokok: 1429900,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 300000,
            potongan_tabungan: 75000,
          },
          "Merchandiser (MD)": {
            gaji_pokok: 1314900,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 200000,
            potongan_tabungan: 50000,
          },
          "Kasir": {
            gaji_pokok: 935000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 150000,
            potongan_tabungan: 30000,
          },
          "Pramuniaga (Pramu)": {
            gaji_pokok: 935000,
            transportasi: 100000,
            pulsa: 0,
            tunjangan_jabatan: 0,
            potongan_tabungan: 30000,
          },
          "Trainee": {
            gaji_pokok: 927890,
            transportasi: 0,
            pulsa: 0,
            tunjangan_jabatan: 0,
            potongan_tabungan: 0,
          },
        },
      },
    };

    // Fungsi pembantu untuk mendapatkan tipe toko berdasarkan PC Code
    const getTipeToko = (jabatan) => {
      if (listRetail.some((pcCode) => jabatan.includes(pcCode)))
        return "Retail";
      if (listSemiGrosir.some((pcCode) => jabatan.includes(pcCode)))
        return "Semi Grosir";
      if (listGrosir.some((pcCode) => jabatan.includes(pcCode)))
        return "Grosir";
      return null; // Jika tidak ada tipe toko yang cocok
    };

    // Validasi input awal
    if (!dataEdit || !dataEdit.nama_jabatan || !dataEdit.tipe_agunan) {
      console.warn("Input tidak lengkap untuk kalkulasi gaji karyawan.");
      return;
    }

    // Ekstraksi tipe toko, tipe agunan, dan jabatan utama
    const tipeToko = getTipeToko(dataEdit.nama_jabatan);
    const tipeAgunan = dataEdit.tipe_agunan.includes("SMA") ? "SMA" : "SMP";
    // Mengambil bagian jabatan yang tepat (misal: "Kepala Toko(KT)")
    const jabatanUtama = dataEdit.nama_jabatan.split(" - ")[0];

    // Ambil data gaji dan tunjangan berdasarkan kriteria
    const gajiDanTunjangan = GAJI_DATA[tipeToko]?.[tipeAgunan]?.[jabatanUtama];

    if (gajiDanTunjangan) {
      // Set gaji pokok menggunakan setter useState
      setBaseGajiPokok(gajiDanTunjangan.gaji_pokok);

      // Set semua field Formik secara dinamis
      formik.setFieldValue("transportasi", gajiDanTunjangan.transportasi || 0);
      formik.setFieldValue("pulsa", gajiDanTunjangan.pulsa || 0);
      formik.setFieldValue(
        "tunjangan_jabatan",
        gajiDanTunjangan.tunjangan_jabatan || 0
      );
      formik.setFieldValue(
        "potongan_tabungan",
        gajiDanTunjangan.potongan_tabungan || 0
      );
      // Tambahkan field lain jika ada di GAJI_DATA (misal: uang_makan, dll.)
      // formik.setFieldValue("uang_makan", gajiDanTunjangan.uang_makan || 0);
    } else {
      console.warn(
        `Data gaji tidak ditemukan untuk kombinasi: Tipe Toko: ${tipeToko}, Agunan: ${tipeAgunan}, Jabatan: ${jabatanUtama}. Mengatur nilai ke 0.`
      );
      // Atur semua nilai ke 0 jika kombinasi tidak ditemukan
      setBaseGajiPokok(0);
      formik.setFieldValue("transportasi", 0);
      formik.setFieldValue("pulsa", 0);
      formik.setFieldValue("tunjangan_jabatan", 0);
      formik.setFieldValue("potongan_tabungan", 0);
    }

    formik.setFieldValue(
      "sisa_nbh_bln_ini",
      parseFloat(dataEdit.sisa_nbh_bln_ini)
    );
  };

  const kalkulasiUangMakan = (value) => {
    const jabatan = dataEdit.nama_jabatan.split(" - ")[0];

    let nominal = 0;

    if (jabatan === "Kepala Toko(KT)") {
      nominal = 455000;
    } else if (
      jabatan === "Asisten Kepala Toko(AKT)" ||
      jabatan === "Merchandiser (MD)" ||
      jabatan === "Kasir" ||
      jabatan === "Pramuniaga (Pramu)" ||
      jabatan === "Trainee"
    ) {
      nominal = 377000;
    }

    if (nominal > 0) {
      const calculateUangMakan = Math.round((value / 26) * nominal);
      formik.setFieldValue("uang_makan", calculateUangMakan);
    }
  };

  const formatFieldLabel = (field) => {
    if (field === "sisa_nbh_bln_ini") return "Sisa NBH Bulan Lalu";
    if (field === "nbh_bln_ini") return "NBH Bulan Ini";
    if (field === "potongan_nbh") return "Potongan NBH";
    return field.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase());
  };

  const formatRupiahValue = (amount) => {
    if (amount === null || amount === undefined) return "Rp 0";
    const absoluteAmount = Math.abs(amount);
    const formatted = absoluteAmount.toLocaleString("id-ID", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
    return `Rp ${formatted}`;
  };

  return (
    <Box p="2rem" maxWidth="1000px" mx="auto">
      <Header
        title={`Edit Data Gaji`}
        subtitle={`${getNamaBulan(dataEdit?.bulan)} - ${dataEdit?.tahun}`}
      />

      <form onSubmit={formik.handleSubmit}>
        {dataEdit && (
          <Card
            elevation={3}
            sx={{
              mt: 3,
              borderRadius: 4,
              overflow: "hidden",
              background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
            }}
          >
            <Box
              sx={{
                background: `linear-gradient(135deg, ${theme.palette.secondary.light} 0%, ${theme.palette.secondary.main} 100%)`,
                p: 3,
                color: "white",
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Avatar
                sx={{
                  bgcolor: "rgba(255,255,255,0.2)",
                  width: 56,
                  height: 56,
                }}
              >
                <WorkHistory sx={{ fontSize: 32 }} />
              </Avatar>
              <Box>
                <Typography variant="h5" fontWeight="bold">
                  Summary Pekerjaan
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Detail informasi pekerjaan karyawan
                </Typography>
              </Box>
            </Box>

            <CardContent sx={{ p: 4 }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    gutterBottom
                  >
                    Riwayat Jabatan:
                  </Typography>
                  {summary_absensi?.data_jenjang?.map((item, index) => {
                    const tanggalMulai = moment(
                      item.tanggal_berlaku
                    ).format("DD/MM/YYYY");
                    const tanggalAkhir = item.tanggal_berakhir
                      ? moment(item.tanggal_berakhir).format("DD/MM/YYYY")
                      : "Saat Ini";
                    return (
                      <Typography
                        key={index}
                        variant="body2"
                        sx={{ mb: 0.5 }}
                      >
                        {`${index + 1}. ${item.nama_jabatan} (${tanggalMulai} - ${tanggalAkhir})`}
                      </Typography>
                    );
                  })}
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="body2">
                    <strong>Tipe Agunan:</strong> {dataEdit?.tipe_agunan}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="body2">
                    <strong>Jabatan:</strong> {dataEdit?.nama_jabatan}
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="body2">
                    <strong>Hari Kerja:</strong> {dataEdit?.jumlah_hadir} Hari
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="body2">
                    <strong>Total Telat:</strong> {dataEdit?.total_telat} Menit
                  </Typography>
                </Grid>

                <Grid item xs={12} md={6}>
                  <Typography variant="body2">
                    <strong>Tabungan:</strong>{" "}
                    {formatRupiah(
                      parseFloat(dataEdit?.total_tabungan) -
                        parseFloat(dataEdit?.potongan_tabungan)
                    )}
                  </Typography>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        )}

        {dataEdit && (
          <Card
            elevation={3}
            sx={{
              mt: 3,
              borderRadius: 4,
              overflow: "hidden",
              background: `linear-gradient(135deg, ${theme.palette.background.paper} 0%, ${theme.palette.background.default} 100%)`,
            }}
          >
            <Box
              sx={{
                background: `linear-gradient(135deg, ${theme.palette.secondary.light} 0%, ${theme.palette.secondary.main} 100%)`,
                p: 3,
                color: "white",
                display: "flex",
                alignItems: "center",
                gap: 2,
              }}
            >
              <Avatar
                sx={{
                  bgcolor: "rgba(255,255,255,0.2)",
                  width: 56,
                  height: 56,
                }}
              >
                <CalculateOutlined sx={{ fontSize: 32 }} />
              </Avatar>
              <Box>
                <Typography variant="h5" fontWeight="bold">
                  Form Penggajian
                </Typography>
                <Typography variant="body2" sx={{ opacity: 0.9 }}>
                  Edit detail penggajian karyawan
                </Typography>
              </Box>
            </Box>

            <CardContent sx={{ p: 4 }}>
              <Box
                sx={{
                  mb: 4,
                  p: 3,
                  borderRadius: 3,
                  bgcolor:
                    theme.palette.mode === "dark"
                      ? "rgba(255,255,255,0.05)"
                      : "rgba(0,0,0,0.02)",
                  border: `1px solid ${theme.palette.divider}`,
                }}
              >
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  mb={2}
                  fontWeight="bold"
                >
                  INFORMASI GAJI
                </Typography>
                <Typography variant="body2" mb={2}>
                  {`*Gaji Pokok perhari (${formatRupiah(baseGajiPokok)} / 26): ${formatRupiah(
                    baseGajiPokok / 26
                  )}`}
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Gaji Pokok"
                      name="gaji_pokok"
                      disabled
                      type="text"
                      value={formik.values.gaji_pokok}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <MoneyOutlined color="action" />
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          bgcolor:
                            theme.palette.mode === "dark"
                              ? "rgba(255,255,255,0.05)"
                              : "rgba(0,0,0,0.02)",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Total Hari Kerja"
                      name="total_hadir"
                      type="text"
                      inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                      value={String(baseTotalHadir)}
                      onChange={(e) => {
                        const { value } = e.target;
                        const digits = value.replace(/\D/g, "");
                        if (Number(digits) >= 0 && Number(digits) <= 27) {
                          setBaseTotalHadir(Number(digits));
                          const calculateGaji = Math.round(
                            (baseGajiPokok / 26) * Number(digits)
                          );
                          kalkulasiUangMakan(Number(digits));
                          formik.setFieldValue("gaji_pokok", calculateGaji);
                        }
                      }}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <WorkHistory color="action" />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>

              <Divider sx={{ my: 3 }} />

              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  mb={2}
                  fontWeight="bold"
                >
                  TUNJANGAN & PENDAPATAN
                </Typography>
                <Grid container spacing={3}>
                  {[
                    "lembur",
                    "rajin",
                    "transportasi",
                    "pulsa",
                    "tunjangan_jabatan",
                    "uang_makan",
                  ].map((field) => (
                    <Grid item xs={12} md={6} key={field}>
                      <TextField
                        fullWidth
                        label={formatFieldLabel(field)}
                        name={field}
                        disabled={
                          field !== "nbh_bln_ini" &&
                          field !== "potongan_nbh" &&
                          field !== "potongan_pinjaman" &&
                          field !== "tunjangan_jabatan" &&
                          field !== "lembur" &&
                          field !== "rajin"
                        }
                        type="text"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        value={String(formik.values[field] || 0)}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          const digits = value.replace(/\D/g, "");
                          const cleaned = digits.replace(/^0+/, "") || "0";
                          formik.setFieldValue(name, Number(cleaned));
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <MoneyOutlined color="action" />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 2,
                          },
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Box>

              <Divider sx={{ my: 3 }} />

              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  mb={2}
                  fontWeight="bold"
                >
                  POTONGAN
                </Typography>
                <Grid container spacing={3}>
                  {[
                    "sisa_nbh_bln_ini",
                    "nbh_bln_ini",
                    "potongan_nbh",
                    "potongan_tabungan",
                    "potongan_pinjaman",
                  ].map((field) => (
                    <Grid item xs={12} md={6} key={field}>
                      <TextField
                        fullWidth
                        label={formatFieldLabel(field)}
                        name={field}
                        type="text"
                        inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
                        value={String(formik.values[field] || 0)}
                        onChange={(e) => {
                          const { name, value } = e.target;
                          const digits = value.replace(/\D/g, "");
                          const cleaned = digits.replace(/^0+/, "") || "0";
                          formik.setFieldValue(name, Number(cleaned));
                        }}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <CalculateOutlined color="action" />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          "& .MuiOutlinedInput-root": {
                            borderRadius: 2,
                          },
                        }}
                      />
                    </Grid>
                  ))}
                </Grid>
              </Box>

              <Divider sx={{ my: 3 }} />

              <Box sx={{ mb: 4 }}>
                <Typography
                  variant="subtitle2"
                  color="text.secondary"
                  mb={2}
                  fontWeight="bold"
                >
                  RINGKASAN
                </Typography>
                <Grid container spacing={3}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Sisa NBH"
                      name="sisa_nbh"
                      type="text"
                      value={String(hitungSisaNBH())}
                      disabled
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <WorkHistory color="action" />
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          bgcolor:
                            theme.palette.mode === "dark"
                              ? "rgba(255,255,255,0.05)"
                              : "rgba(0,0,0,0.02)",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      fullWidth
                      label="Estimasi Total Tabungan"
                      name="total_tabungan"
                      type="text"
                      value={formatRupiahValue(hitungEstimasiTabungan())}
                      disabled
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Savings color="action" />
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          bgcolor:
                            theme.palette.mode === "dark"
                              ? "rgba(255,255,255,0.05)"
                              : "rgba(0,0,0,0.02)",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Total Pendapatan"
                      name="total_income"
                      type="text"
                      value={formatRupiahValue(hitungIncome())}
                      disabled
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <MoneyOutlined color="action" />
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          bgcolor:
                            theme.palette.mode === "dark"
                              ? "rgba(255,255,255,0.05)"
                              : "rgba(0,0,0,0.02)",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Total Potongan"
                      name="total_outcome"
                      type="text"
                      value={formatRupiahValue(hitungOutcome())}
                      disabled
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <CalculateOutlined color="action" />
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          bgcolor:
                            theme.palette.mode === "dark"
                              ? "rgba(255,255,255,0.05)"
                              : "rgba(0,0,0,0.02)",
                        },
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Total Gaji"
                      name="total_gaji"
                      type="text"
                      value={formatRupiahValue(hitungTotalGaji())}
                      disabled
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Savings color="action" />
                          </InputAdornment>
                        ),
                        readOnly: true,
                      }}
                      sx={{
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                          bgcolor:
                            theme.palette.mode === "dark"
                              ? "rgba(255,255,255,0.05)"
                              : "rgba(0,0,0,0.02)",
                          "& > fieldset": {
                            borderColor: theme.palette.secondary.main,
                            borderWidth: 2,
                          },
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>

              <Divider sx={{ my: 3 }} />

              <FlexStart gap={2} sx={{ flexWrap: "wrap" }}>
                <Button
                  type="submit"
                  variant="contained"
                  size="large"
                  disabled={hitungTotalGaji() === 0}
                  startIcon={<AddCircleOutline />}
                  sx={{
                    background: theme.palette.secondary.main,
                    fontSize: "14px",
                    fontWeight: "bold",
                    padding: "12px 28px",
                    borderRadius: 2,
                    textTransform: "none",
                    boxShadow: `0 4px 14px ${theme.palette.secondary.main}40`,
                    "&:hover": {
                      background: theme.palette.secondary[300],
                      transform: "translateY(-2px)",
                      boxShadow: `0 6px 20px ${theme.palette.secondary.main}50`,
                    },
                    "&:disabled": {
                      bgcolor: theme.palette.grey[300],
                      color: theme.palette.grey[500],
                    },
                    color: "#ffffff",
                    transition: "all 0.3s ease",
                  }}
                >
                  Simpan
                </Button>
                <Button
                  type="button"
                  variant="outlined"
                  size="large"
                  onClick={() => {
                    navigate(-1);
                    formik.resetForm();
                  }}
                  startIcon={<CancelOutlined />}
                  sx={{
                    fontSize: "14px",
                    fontWeight: "bold",
                    padding: "12px 28px",
                    borderRadius: 2,
                    textTransform: "none",
                    borderColor: theme.palette.error.main,
                    color: theme.palette.error.main,
                    "&:hover": {
                      borderColor: theme.palette.error.dark,
                      color: theme.palette.error.dark,
                      bgcolor: `${theme.palette.error.main}10`,
                    },
                    transition: "all 0.3s ease",
                  }}
                >
                  Batal
                </Button>
              </FlexStart>
            </CardContent>
          </Card>
        )}
      </form>
      <FloatingAlert
        open={message.length > 0}
        onClose={handleCloseSnackbar}
        message={message}
        severity={status === "failed" ? "error" : status}
      />
    </Box>
  );
};

export default EditPenggajian;
